import * as types from './actionTypes';  
import customerResetPassApi from '../api/customerResetPassApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCustomerResetPass(request) {

  return {
    type: types.DO_CUSTOMER_RESET_PASSWORD, 
    request
  };
}

export function doCustomerResetPassRes(data) {  
  return {
    type: types.DO_CUSTOMER_RESET_PASSWORD_RES, 
    data
  };
}

export function sendCustomerResetPassword(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      customerResetPassApi.doCustomerResetPass(request).then(data => {
        dispatch(doCustomerResetPassRes(data));
        dispatch(doCustomerResetPassRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}